import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './root/_services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from './root/_services/spinner.service';
import { CheckProfileService } from './root/_services/check-profile.service';
import { ItmModalComponent } from './shared/ui-component/itm-modal/itm-modal.component';
import { AppConfig } from './app.config';
import { ResponsiveService } from './root/_services/responsive.service';
import { AlertService } from './root/_services/alert.service';
import * as moment from 'moment';
var AppComponent = /** @class */ (function () {
    function AppComponent(router, config, authenticationService, translateService, spinnerService, checkprofileService, responsiveService, alertService) {
        var _this = this;
        this.router = router;
        this.config = config;
        this.authenticationService = authenticationService;
        this.translateService = translateService;
        this.spinnerService = spinnerService;
        this.checkprofileService = checkprofileService;
        this.responsiveService = responsiveService;
        this.alertService = alertService;
        this.showLoading = true;
        this.profileData = { "messages": [], "showWarning": false };
        this.authenticationService.currentUser.subscribe(function (u) { return _this.currentUser = u; });
        this.translateService.setDefaultLang('it');
        this.spinnerService.change.subscribe(function (value) { return _this.showLoading = value.show; });
    }
    AppComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.setMinHeight();
        window.addEventListener("resize", function () { _this.setMinHeight(); });
    };
    Object.defineProperty(AppComponent.prototype, "menu", {
        get: function () {
            return this.currentUser ? this.currentUser.menu : {};
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.versione = this.config.getVersion("semverString");
        this.checkprofileService.getMessages();
        this.checkprofileService.checkProfileData.subscribe(function (x) {
            _this.profileData.showWarning = x.warningCheckProfile;
            _this.profileData.messages = x.messages;
        });
        this.year = moment().format("Y");
        this.authenticationService.getBackendVersion().subscribe(function (x) {
            if (x.status == "OK")
                _this.versioneBE = x.result;
            else
                _this.alertService.error(x.error_message ? x.error_message : "System error");
        });
    };
    AppComponent.prototype.setMinHeight = function () {
        var h = (window.innerHeight - $("nav.site-header").innerHeight() - $("footer").innerHeight());
        $(".main").css("min-height", h);
        // if ($(".page-container").position()) {
        // 	const ft = $("footer").position().top;
        // 	const ct = $(".page-container").position().top;
        // 	const h2 = ft - ct - 10;
        // 	console.log(ft);
        // 	console.log(ct);
        // 	if (h2 < h)
        // 		$(".page-container").css("min-height", h2);
        // }
        this.responsiveService.setCurrentBreakpoint(window.outerWidth);
    };
    AppComponent.prototype.logout = function () {
        this.authenticationService.logout(true);
        this.router.navigate(['/login']);
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this.checkprofileService.checkProfileData.unsubscribe();
    };
    AppComponent.prototype.showWarning = function () {
        this.modalWarning.show();
    };
    AppComponent.prototype.toggleMenu = function () {
        $('.navbar-collapse').collapse('hide');
    };
    return AppComponent;
}());
export { AppComponent };
;
